import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Snackbar, Alert, Button } from '@mui/material';
import { useSocket } from '../../context/SocketContext';

/**
 * Tells a client, wherever they are in the app, that their therapist has just shared a
 * summary of their call (consult item 9, Dave 1 Oct 2026: option 4). Before this,
 * sharing told the client nothing; the summary waited on a page they had to find.
 */
export default function SummarySharedNotice({ currentUser }) {
  const socket = useSocket();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!socket) return undefined;
    const onShared = () => setOpen(true);
    socket.on('server:summary:shared', onShared);
    return () => socket.off('server:summary:shared', onShared);
  }, [socket]);

  const roles = Array.isArray(currentUser?.role) ? currentUser.role : [currentUser?.role];
  if (!roles.includes('client')) return null;
  const target = currentUser?.effectiveClientUIMode === 'patient_portal' ? '/portal/summaries' : '/summaries';

  return (
    <Snackbar open={open} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} onClose={(_, reason) => { if (reason !== 'clickaway') setOpen(false); }}>
      <Alert
        severity="info"
        onClose={() => setOpen(false)}
        action={<Button color="inherit" size="small" onClick={() => { setOpen(false); navigate(target); }}>Read it</Button>}
      >
        Your therapist has shared a summary of your call.
      </Alert>
    </Snackbar>
  );
}
